import * as authAction from '@/store/modules/auth/action-types'
import * as roomServiceAction from '@/store/modules/roomservice/action-types'
import * as administrationAction from '@/store/modules/administration/action-types'
import * as uiAction from '@/store/modules/ui/action-types'

export default {  
  ...authAction,
  ...roomServiceAction,
  ...administrationAction,
  ...uiAction
}